export default __webpack_public_path__ + "static/media/logo.87e41c24.png";